export const notificationsOptions = {
  duration: 20000,
};
